import { useTranslation } from 'react-i18next';
import { TPayment, TPersonnel } from '../types';
import { PAYMENT_TYPES } from '../utils/enums';
import { useAppSelector } from './useAppStore';
import { getCurrencyById } from '../store/common/selectors';

export function usePayment() {
  const getCurrency = useAppSelector(getCurrencyById);
  const { t } = useTranslation('common');
  const getAmountString = <T extends { personnel?: TPersonnel; payment: TPayment }>(
    item: T,
  ) => {
    const currencyMark = getCurrency(item.personnel?.paymentCurrencyId
      || item.payment.paymentCurrencyId).mark;

    const suffix = item.payment?.paymentType === PAYMENT_TYPES.Salary
      ? t('month')
      : t('hour');

    const isPaymentType = item.payment?.paymentType in PAYMENT_TYPES
      && item.payment?.paymentAmount;

    return isPaymentType
      ? `${currencyMark}${item.payment?.paymentAmount} /${suffix}`
      : '/';
  };

  return {
    getAmountString,
  };
}
